import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { _get, _delete } from "../../services/apiClient";
import { Button, Table, Spinner } from "react-bootstrap";
import FeatherIcon from "feather-icons-react";

interface Item {
  id: number;
  name: string;
  category: string;
  price: number;
  stock: number;
  created_at: string;
}

export default function SampleList() {
  const navigate = useNavigate();
  const [items, setItems] = useState<Item[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchItems = async () => {
    try {
      setLoading(true);
      const res = await _get<Item[]>("/items");
      setItems(res.data);
    } catch (err) {
      console.error("Failed to fetch items:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id: number) => {
    if (!window.confirm("Are you sure you want to delete this item?")) return;
    try {
      await _delete(`/items/${id}`);
      setItems(items.filter((i) => i.id !== id));
      alert("Item deleted successfully!");
    } catch (err) {
      console.error("Delete failed:", err);
    }
  };

  useEffect(() => {
    fetchItems();
  }, []);

  return (
    <div className="container-fluid p-0">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h1 className="h3">Items</h1>
        <Button variant="primary" onClick={() => navigate("/items/create")}>
          <FeatherIcon icon="plus" /> Add New Item
        </Button>
      </div>

      {loading ? (
        <div className="text-center py-5">
          <Spinner animation="border" />
        </div>
      ) : items.length === 0 ? (
        <p>No items found.</p>
      ) : (
        <Table striped hover responsive>
          <thead className="table-dark">
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Category</th>
              <th>Price</th>
              <th>Stock</th>
              <th>Created</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, i) => (
              <tr key={item.id}>
                <td>{i + 1}</td>
                <td>{item.name}</td>
                <td>{item.category}</td>
                <td>${item.price}</td>
                <td>{item.stock}</td>
                <td>{new Date(item.created_at).toLocaleDateString()}</td>
                <td>
                  <Button
                    variant="outline-info"
                    size="sm"
                    className="me-2"
                    onClick={() => navigate(`/items/${item.id}/edit`)}
                  >
                    <FeatherIcon icon="edit" size={16} />
                  </Button>
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => handleDelete(item.id)}
                  >
                    <FeatherIcon icon="trash-2" size={16} />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </div>
  );
}
